require './Form'
window.TableForm = class TableForm extends Form
  constructor: (className)->
    super
    @piece = P.table("table-form #{className}")
  build: ->
    @piece

